import { type IStoreState } from "@/vue/planning/store/state/state"
import { WiypResponse } from "@/types/responses"

export default {
	wiypCall: (state: IStoreState): Record<string, Record<string, WiypResponse>> => {
		return state.wiypCall;
	},
	getWiypCallByFamilyCompositionAndPackageCode: (state: IStoreState) => (familyComposition: string, packageCode: string): Record<string, WiypResponse> | undefined => {
		return state.wiypCall[familyComposition][packageCode];
	},
	getWiypCallByFamilyCompositionAndPackageCodeAndId: (state: IStoreState) => (familyComposition: string, packageCode: string, packageId: string): WiypResponse | undefined => {
		return state.wiypCall[familyComposition]?.[packageCode]?.[packageId];
	},
}

